import dayjs from "dayjs";

export function normalizeYmd(value) {
  const s = (value != null ? String(value) : "").trim();
  if (!s) return dayjs().format("YYYY-MM-DD");
  const d = dayjs(s);
  return d.isValid() ? d.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
}

export function getNavigatorRangeTitle({ view, focusDateYmd }) {
  if (view === "all") return "All Time";
  const focus = dayjs(normalizeYmd(focusDateYmd));
  if (view === "future") {
    const start = focus.add(1, "month").startOf("month");
    return `${start.format("MMM D, YYYY")} – Beyond`;
  }
  if (view === "day") return focus.format("ddd, MMM D, YYYY");
  if (view === "week") {
    const weekStart = focus.startOf("week");
    const weekEnd = focus.endOf("week");
    return `${weekStart.format("MMM D")} – ${weekEnd.format("MMM D, YYYY")}`;
  }
  // month
  return focus.format("MMMM YYYY");
}

export function getNavigatorRangeBounds({ view, focusDateYmd }) {
  if (view === "all") {
    return { startInclusive: null, endInclusive: null };
  }
  const focus = dayjs(normalizeYmd(focusDateYmd));
  if (view === "future") {
    const start = focus.add(1, "month").startOf("month").startOf("day");
    return { startInclusive: start.toISOString(), endInclusive: null };
  }
  if (view === "day") {
    return {
      startInclusive: focus.startOf("day").toISOString(),
      endInclusive: focus.endOf("day").toISOString(),
    };
  }
  if (view === "week") {
    return {
      startInclusive: focus.startOf("week").startOf("day").toISOString(),
      endInclusive: focus.endOf("week").endOf("day").toISOString(),
    };
  }
  return {
    startInclusive: focus.startOf("month").startOf("day").toISOString(),
    endInclusive: focus.endOf("month").endOf("day").toISOString(),
  };
}

/** True when a record's start/end overlaps the navigator range (same rules as Events list). */
export function recordOverlapsNavigatorRange(record, bounds, view) {
  const start = record?.start_datetime ? dayjs(record.start_datetime) : null;
  const end = record?.end_datetime ? dayjs(record.end_datetime) : null;
  const a = start && start.isValid() ? start : end && end.isValid() ? end : null;
  const b = end && end.isValid() ? end : start && start.isValid() ? start : null;
  if (!a || !b) return false;

  const rangeStart = bounds?.startInclusive ? dayjs(bounds.startInclusive) : null;
  const rangeEnd = bounds?.endInclusive ? dayjs(bounds.endInclusive) : null;
  if (!rangeStart && !rangeEnd) return true;

  const viewKey = (view != null ? String(view) : "").trim().toLowerCase();
  if (viewKey === "future") {
    if (rangeStart && a.isBefore(rangeStart)) return false;
  } else {
    if (rangeStart && b.isBefore(rangeStart)) return false;
    if (rangeEnd && a.isAfter(rangeEnd)) return false;
  }
  return true;
}

export function moveNavigatorFocus({ view, focusDateYmd, dir }) {
  if (view === "all") return normalizeYmd(focusDateYmd);
  const focus = dayjs(normalizeYmd(focusDateYmd));
  const step = dir === "prev" ? -1 : 1;
  if (view === "day") return focus.add(step, "day").format("YYYY-MM-DD");
  if (view === "week") return focus.add(step, "week").format("YYYY-MM-DD");
  if (view === "future") return focus.add(step, "month").format("YYYY-MM-DD");
  return focus.add(step, "month").format("YYYY-MM-DD");
}

